/**
 * Trial length an admin may grant, in days (PRD A-3); 14 unless the admin
 * changes it. Read by the approval of a sign-up request and by «Новый аккаунт».
 *
 * A module of its own so every schema file can import it: `signup.ts` imports
 * `subscription.ts`, which imports `account.ts`, so `account.ts` importing
 * `signup.ts` would close a cycle and load one of them half-initialised.
 */
export const TRIAL_DAYS_MIN = 1;
export const TRIAL_DAYS_MAX = 365;
export const TRIAL_DAYS_DEFAULT = 14;
//# sourceMappingURL=trial-days.js.map